module.exports = "<div *ngIf=\"showLoadingScreen\" class=\"row flex-items-xs-middle content-loader\">\n    <div class=\"col-xs\">\n        <div class=\"spinner spinner-lg\"></div>\n    </div>\n</div>\n<div [hidden]=\"showLoadingScreen\" class=\"tableHolder\" >\n    <table class=\"row-border\" [ngClass]=\"classNames\"></table>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/common/vca-grid/vca-grid.html
// module id = XHyj
// module chunks = 0